import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isAndroid, isIOS } from 'react-device-detect';
import { createGlobalStyle } from 'styled-components';
import { InAppBrowserGate } from '../components/InAppBrowserGate';
import { StreamrAppMobileView } from '../components/streamrapp/StreamrAppMobileView';
import { StreamrAppView } from '../components/streamrapp/StreamrAppView';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { LobbyService } from '../services/lobby/LobbyService';
import { StreamrAppService } from '../services/streamrapp/StreamrAppService';
// Disable every `backdrop-filter: blur()` on the session page. The frosted-glass
// overlays (control bar, film strip, popups, etc.) sit over the live video, so
// the GPU re-blurs the video region on EVERY frame. Measured 2026-06-14 (Safari
// rendering timeline, guest): the blurs cost ~18-36% of wall time in layer
// compositing and capped the rendered frame rate at ~11 fps; disabling them cut
// compositing to <1% and restored ~40 fps, with no perceptible visual change.
// Far more expensive on iOS, where this is a meaningful thermal contributor.
// `!important` overrides the styled-component rules. Document-level, mounted
// only while a session page is open.
const DisableBackdropFilters = createGlobalStyle `
    * {
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
    }
`;
export function StreamrAppPage() {
    return (_jsxs(_Fragment, { children: [_jsx(DisableBackdropFilters, {}), _jsx(InAppBrowserGate, { children: _jsx(StreamrAppPageContent, {}) })] }));
}
function StreamrAppPageContent() {
    const activeBroadcast = BroadcastStateService.getOutput().useActiveBroadcast();
    if (activeBroadcast === undefined) {
        StreamrAppService.getInstance().notifyInitializeBroadcastFromUrl();
        return null;
    }
    LobbyService.getInstance().notifyEnterLobby(activeBroadcast);
    if (isIOS || isAndroid) {
        return _jsx(StreamrAppMobileView, {});
    }
    return _jsx(StreamrAppView, {});
}
